export enum HoldState {
    BOUGHT = 'BOUGHT',
    SOLD = 'SOLD',
}

export enum Market {
    SZ = 'SZ',
    SH = 'SH',
}

export enum RecommendState {
    BUY = 'BUY',
    SELL = 'SELL',
}

export enum RecommendSource {
    MIN7 = 'MIN7',
    SELF = 'SELF',
}

export const TagColor = ['#32cd32', '#ef5767', '#0066ff', '#666666'];
